export default __webpack_public_path__ + "static/media/wait.30e329da.mp3";